var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { API_URLS } from '../../constants/apiConstants';
import { TV_LOGIN_TYPE } from '../../constants/commonConstants';
import { GATEWAY_URL } from '../../utils/common/apiConfig';
import httpPost from '../../utils/http/httpPost';
/**
 * 로그인 개선으로 아이디/비밀번호를 통해 로그인을 시도합니다.
 */
var fetchAppLogin = function (requestParameter, requestConfig) {
    var userId = requestParameter.userId, password = requestParameter.password, loginType = requestParameter.loginType, deviceId = requestParameter.deviceId, deviceName = requestParameter.deviceName, deviceModel = requestParameter.deviceModel;
    // 모든 파라미터가 없는 경우 에러 발생
    if (!userId && !password && !loginType && !deviceId && deviceName) {
        throw new Error('fetchAppLogin: requestParameter is invalid');
    }
    var requestBodyParams = JSON.stringify({
        userId: userId,
        password: password,
        loginType: loginType,
        deviceId: deviceId,
        deviceName: deviceName,
        deviceModel: deviceModel,
    });
    var loginPath = loginType === TV_LOGIN_TYPE.TVING_ID ? 'tving' : 'cjone';
    var filledRequestConfig = __assign(__assign({}, requestConfig), { data: requestBodyParams });
    return httpPost("".concat(GATEWAY_URL).concat(API_URLS.APP_LOGIN).concat(loginPath), filledRequestConfig)
        .then(function (response) {
        return response;
    })
        .catch(function (e) {
        throw e;
    });
};
export default fetchAppLogin;
